import React, { useState, useEffect, useCallback } from 'react';
import { THEME } from '../../constants/theme';
import API from '../../services/api';

// External Components
import SuppliersSection from './SuppliersSection';
import AddPurchaseForm from './AddPurchaseForm';
import BikeLifeCycleView from './BikeLifeCycleView'; 

// ==========================================
// 📌 SUB-COMPONENT: REGISTRATION DESK
// ==========================================
const RegistrationDesk = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [bike, setBike] = useState(null);
    const [regNumber, setRegNumber] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        if (!searchTerm) return;
        setLoading(true);
        try {
            const res = await API.get(`/v1/bikes/search-by-identity?term=${searchTerm}`);
            if (res.data.success) {
                setBike(res.data.data);
                setRegNumber(res.data.data.current_reg || '');
            } else {
                alert("Bike not found!");
                setBike(null);
            }
        } catch (err) { alert("Error searching bike"); }
        finally { setLoading(false); }
    };

    const handleAssign = async () => {
        if (!regNumber) return alert("Please enter a number");
        try {
            const res = await API.post('/v1/bikes/assign-number', {
                bike_master_id: bike.bike_master_id,
                reg_number: regNumber
            });
            if (res.data.success) {
                alert("Registration Successful!");
                setBike(null);
                setSearchTerm('');
            }
        } catch (err) { alert("Failed to assign number"); }
    };

    return (
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div style={styles.tableCard}>
                <div style={{ padding: '30px' }}>
                    <h3 style={{ marginTop: 0 }}>Registration Assignment</h3>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                        <input 
                            style={styles.searchInput} 
                            placeholder="Engine or Chassis #" 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button onClick={handleSearch} style={styles.searchBtn}>{loading ? '...' : 'Search'}</button>
                    </div>

                    {bike && (
                        <div style={{ background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                            <div style={{ marginBottom: '15px' }}>
                                <strong>{bike.model_name}</strong>
                                <div style={{ fontSize: '13px', color: '#64748b' }}>E: {bike.engine_number}</div>
                            </div>
                            <input 
                                style={{ ...styles.searchInput, fontSize: '22px', textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }} 
                                placeholder="ABC-1234" 
                                value={regNumber}
                                onChange={(e) => setRegNumber(e.target.value)}
                            />
                            <button onClick={handleAssign} style={styles.saveBtn}>Save Registration</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// ==========================================
// 📊 SUB-COMPONENT: INVENTORY SECTION
// ==========================================
const InventorySection = () => {
    const [stock, setStock] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState('');
    const [viewingBikeId, setViewingBikeId] = useState(null);

    const limit = 10;

    const fetchStock = useCallback(async () => {
        setLoading(true);
        try {
            const res = await API.get(`/v1/inventory/live-stock`, {
                params: { page: currentPage, limit: limit, search: search }
            });
            setStock(res.data.data || []);
            setTotalRecords(res.data.total || 0);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    }, [currentPage, search]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => fetchStock(), 500);
        return () => clearTimeout(delayDebounce);
    }, [fetchStock]);

    const totalPages = Math.ceil(totalRecords / limit);

    return (
        <div>
            <div style={styles.statsRow}>
                <div style={styles.statCard}>
                    <span style={styles.statLabel}>Total Units</span>
                    <span style={styles.statValue}>{totalRecords}</span>
                </div>
                <div style={{ ...styles.statCard, flex: 2 }}>
                    <span style={styles.statLabel}>Quick Search</span>
                    <input 
                        placeholder="Search Engine, Chassis or Model..."
                        style={styles.searchInput}
                        value={search}
                        onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
                    />
                </div>
            </div>

            <div style={styles.tableCard}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>Model & Color</th>
                            <th style={styles.th}>Chassis / Engine</th>
                            <th style={styles.th}>Cost</th>
                            <th style={styles.th}>Status</th>
                            <th style={styles.th}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="5" style={styles.loader}>Loading Inventory Data...</td></tr>
                        ) : stock.length > 0 ? (
                            stock.map((item) => (
                                <tr key={item.id} style={styles.tr}>
                                    <td style={styles.td}>
                                        <div style={{ fontWeight: 'bold' }}>{item.model_name}</div>
                                        <div style={{ fontSize: '11px', color: '#64748b' }}>{item.color}</div>
                                    </td>
                                    <td style={styles.td}>
                                        <div style={{ fontSize: '12px' }}>C: {item.chassis_number}</div>
                                        <div style={{ fontSize: '12px' }}>E: {item.engine_number}</div>
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: 'bold' }}>Rs. {Number(item.purchase_price).toLocaleString()}</td>
                                    <td style={styles.td}><span style={styles.statusBadge}>{item.stock_status}</span></td>
                                    <td style={styles.td}>
    <button 
    onClick={() => {
        // Step 1: ID uthayein (jo 36:1 ho sakti hai)
        const rawId = item.bike_master_id || item.id;
        
        // Step 2: Colon (:) ko khatam karke sirf number nikalein
        // Ye "36:1" ko "36" bana dega
        const cleanId = String(rawId).split(':')[0]; 

        console.log("Requesting clean ID:", cleanId); // Check karein console mein sirf "36" aana chahiye
        setViewingBikeId(cleanId);
    }} 
    style={styles.viewBtn}
>
    View Profile
</button>
                            </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="5" style={{padding: '20px', textAlign: 'center'}}>No Records Found</td></tr>
                        )}
                    </tbody>
                </table>
                <div style={styles.paginationRow}>
                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} style={styles.pageBtn}>Prev</button>
                    <span style={{ fontSize: '13px' }}>Page {currentPage} of {totalPages}</span>
                    <button disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)} style={styles.pageBtn}>Next</button>
                </div>
            </div>

            {/* 🛡️ BIKE LIFE CYCLE DIALOG (Isi Section ke andar connect kar diya) */}
            {viewingBikeId && (
                <BikeLifeCycleView 
                    bikeId={viewingBikeId} 
                    onClose={() => setViewingBikeId(null)} 
                />
            )}
        </div>
    );
};

// ==========================================
// 🏗️ MAIN COMPONENT: PURCHASE PANEL
// ==========================================

const VersionsSection = () => {
    const [data, setData] = useState([]);
    const [newVer, setNewVer] = useState({ model_name: '', version: '' });

    const fetchVersions = async () => {
        const res = await API.get('/v1/versions');
        setData(res.data.data);
    };

    const handleSave = async () => {
        await API.post('/v1/versions', newVer);
        setNewVer({ model_name: '', version: '' });
        fetchVersions();
    };

    const handleDelete = async (id) => {
        if(window.confirm('Are you sure?')) {
            await API.delete(`/v1/versions/${id}`);
            fetchVersions();
        }
    };

    useEffect(() => { fetchVersions(); }, []);

    return (
        <div style={styles.tableCard}>
            <div style={{ padding: '20px', display: 'flex', gap: '10px' }}>
                <input placeholder="Model Name" value={newVer.model_name} onChange={e => setNewVer({...newVer, model_name: e.target.value})} style={styles.searchInput} />
                <input placeholder="Version" value={newVer.version} onChange={e => setNewVer({...newVer, version: e.target.value})} style={styles.searchInput} />
                <button onClick={handleSave} style={styles.saveBtn}>Add</button>
            </div>
            <table style={styles.table}>
                <thead><tr><th>Model</th><th>Version</th><th>Date</th><th>Action</th></tr></thead>
                <tbody>
                    {data.map(item => (
                        <tr key={item.id}>
                            <td>{item.model_name}</td>
                            <td>{item.version}</td>
                            <td>{new Date(item.created_at).toLocaleDateString()}</td>
                            <td><button onClick={() => handleDelete(item.id)} style={{color: 'red'}}>Delete</button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

const PurchasePanel = () => {
    const [activeSubTab, setActiveSubTab] = useState('inventory');

    const menuItems = [
        { id: 'inventory', label: 'Inventory', icon: '📊' },
        { id: 'registration', label: 'Reg. Desk', icon: '📌' },
        { id: 'add_purchase', label: 'Add Stock', icon: '➕' },
        { id: 'suppliers', label: 'Suppliers', icon: '🚛' },
        { id: 'versions', label: 'Versions', icon: '⚙️' },
    ];

    return (
        <div style={styles.wrapper}>
            <div style={styles.container}>
                <div style={styles.topMenu}>
                    {menuItems.map((item) => (
                        <div 
                            key={item.id}
                            onClick={() => setActiveSubTab(item.id)}
                            style={{
                                ...styles.menuItem,
                                borderBottom: activeSubTab === item.id ? `3px solid ${THEME.secondary}` : '3px solid transparent',
                                color: activeSubTab === item.id ? THEME.secondary : '#64748b',
                                backgroundColor: activeSubTab === item.id ? '#f8fafc' : 'transparent',
                            }}
                        >
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </div>
                    ))}
                </div>
                <div style={styles.contentArea}>
                    {activeSubTab === 'inventory' && <InventorySection />}
                    {activeSubTab === 'registration' && <RegistrationDesk />}
                    {activeSubTab === 'add_purchase' && <AddPurchaseForm onComplete={() => setActiveSubTab('inventory')} />}
                    {activeSubTab === 'suppliers' && <SuppliersSection />}
                     {activeSubTab === 'versions' && <VersionsSection />}
                </div>
            </div>
        </div>
    );
};

const styles = {
    wrapper: { height: '100%', display: 'flex', flexDirection: 'column' },
    container: { display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '16px', overflow: 'hidden', flex: 1, border: '1px solid #e2e8f0' },
    topMenu: { display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff' },
    menuItem: { display: 'flex', alignItems: 'center', padding: '18px 25px', cursor: 'pointer', gap: '10px', fontWeight: 'bold', fontSize: '14px', transition: '0.3s' },
    contentArea: { flex: 1, padding: '25px', backgroundColor: '#f8fafc', overflowY: 'auto' },
    statsRow: { display: 'flex', gap: '20px', marginBottom: '25px' },
    statCard: { background: '#fff', padding: '15px', borderRadius: '12px', border: '1px solid #e2e8f0', flex: 1 },
    statLabel: { fontSize: '11px', fontWeight: '900', color: '#64748b', textTransform: 'uppercase' },
    statValue: { fontSize: '24px', fontWeight: '900', color: '#1e293b', display: 'block' },
    searchInput: { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontSize: '14px' },
    tableCard: { background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', overflow: 'hidden' },
    table: { width: '100%', borderCollapse: 'collapse' },
    thead: { background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
    th: { padding: '15px', textAlign: 'left', fontSize: '11px', color: '#64748b', textTransform: 'uppercase' },
    tr: { borderBottom: '1px solid #f1f5f9', transition: '0.2s' },
    td: { padding: '15px', fontSize: '13px' },
    loader: { padding: '40px', textAlign: 'center', color: '#64748b' },
    statusBadge: { background: '#dcfce7', color: '#166534', padding: '4px 10px', borderRadius: '6px', fontSize: '10px', fontWeight: 'bold' },
    viewBtn: { padding: '8px 15px', background: '#1e293b', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' },
    searchBtn: { padding: '0 25px', background: '#1e293b', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' },
    saveBtn: { width: '100%', padding: '15px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', marginTop: '15px' },
    paginationRow: { padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff' },
    pageBtn: { padding: '6px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: '12px' }
};

export default PurchasePanel;